<template>
  <div class="module_list_2">
    <div class="row">
      <div class="module_item_3">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-6"
          v-for="item in modulelist"
          :key="item.id"
          @click="goproductDetail(item.id)"
        >
          <div
            class="m_i_3_1"
            :style="{ backgroundImage: 'url(' + item.iconpath + ')' }"
          >
            <div class="mo_info">
              <div class="mo_title">{{ item.title }}</div>
              <div class="mo_desc">{{ item.subtitle }}</div>
              <div class="mo_price"><i>￥</i>{{ item.show_price }}</div>
              <div class="mo_btn" v-if="is_show">点击查看</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modulelist", "is_show"],
  data() {
    return {};
  },
  methods: {
    goproductDetail(id) {
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
[class*="col-"] {
  padding: 0 0.05rem;
}
.row {
  margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/modulelist2.vue